import { property, makelaar, photos } from "../data/property";
import { Phone, Calendar, Mail } from "lucide-react";
import { trackEvent } from "../lib/analytics";
import Reveal from "./Reveal";

export default function FinalCTA() {
  return (
    <section
      id="contact"
      data-testid="final-cta-section"
      className="relative overflow-hidden bg-brand-ink py-24 text-white md:py-32"
    >
      {/* Background image with overlay */}
      <div className="absolute inset-0 opacity-30">
        <img
          src={photos[32]}
          alt=""
          className="h-full w-full object-cover"
          loading="lazy"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-brand-ink/80 via-brand-ink/70 to-brand-ink" />

      <div className="relative mx-auto max-w-[1600px] px-6 md:px-12 lg:px-20">
        <Reveal className="mx-auto max-w-4xl text-center">
          <p className="overline" style={{ color: "#B89968" }}>
            Plan uw bezichtiging
          </p>
          <h2 className="mt-8 font-serif text-5xl leading-[1.0] tracking-tight sm:text-6xl lg:text-7xl text-balance">
            Kom de sfeer van{" "}
            <span className="italic">{property.address}</span> zelf ervaren.
          </h2>
          <p className="mt-8 mx-auto max-w-2xl text-lg leading-relaxed text-white/75">
            Bel of mail Carole voor een persoonlijke rondleiding. Bij voorkeur op een moment dat u uitkomt — overdag, 's avonds of in het weekend.
          </p>

          {/* Big CTAs */}
          <div className="mt-12 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <a
              data-testid="final-call-btn"
              href={`tel:${makelaar.phoneClean}`}
              onClick={() => trackEvent("cta_click", { location: "final_cta", action: "call" })}
              className="inline-flex w-full items-center justify-center gap-3 bg-white px-10 py-5 text-sm font-medium tracking-wide text-brand-ink transition-all hover:bg-brand-bg sm:w-auto"
            >
              <Phone size={18} />
              Bel direct {makelaar.phone}
            </a>
            <a
              data-testid="final-viewing-btn"
              href={makelaar.viewingUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEvent("cta_click", { location: "final_cta", action: "viewing_request" })}
              className="inline-flex w-full items-center justify-center gap-3 border border-white/40 px-10 py-5 text-sm font-medium tracking-wide text-white transition-all hover:bg-white hover:text-brand-ink sm:w-auto"
            >
              <Calendar size={18} />
              Vraag bezichtiging aan
            </a>
          </div>

          <div className="mt-12 flex flex-col items-center justify-center gap-4 text-sm text-white/60 sm:flex-row sm:gap-10">
            <a
              data-testid="final-email-btn"
              href={`mailto:${makelaar.email}?subject=Interesse Kempenaar 29, Wijk bij Duurstede`}
              onClick={() => trackEvent("cta_click", { location: "final_cta", action: "email" })}
              className="inline-flex items-center gap-2 transition-colors hover:text-white"
            >
              <Mail size={14} />
              {makelaar.email}
            </a>
            <span className="hidden h-4 w-px bg-white/20 sm:block" />
            <span>Doorgaans binnen 24 uur reactie</span>
          </div>

          {/* Trust badge */}
          <div className="mt-16 inline-flex items-center gap-4 border border-white/15 px-6 py-4">
            <img
              src={makelaar.portrait}
              alt={makelaar.name}
              className="h-12 w-12 rounded-full object-cover bg-brand-surface"
            />
            <div className="text-left">
              <p className="font-serif text-lg">{makelaar.name}</p>
              <p className="text-xs text-white/60">
                {makelaar.title} · 9,9 ⭐ op Funda
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
